import { render, staticRenderFns } from "./HomeWishlistFR.vue?vue&type=template&id=0729449b&scoped=true"
import script from "./HomeWishlistFR.vue?vue&type=script&lang=js"
export * from "./HomeWishlistFR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0729449b",
  null
  
)

export default component.exports